/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { Number } from '../../models/number';

export interface MonitoringControllerStatusWidget$Params {
  statusId: number;
}

export function monitoringControllerStatusWidget(http: HttpClient, rootUrl: string, params: MonitoringControllerStatusWidget$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: Number;
}>> {
  const rb = new RequestBuilder(rootUrl, monitoringControllerStatusWidget.PATH, 'get');
  if (params) {
    rb.query('statusId', params.statusId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: Number;
      }>;
    })
  );
}

monitoringControllerStatusWidget.PATH = '/monitoring/status-widget';
